import { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';

import { ComponentLink } from 'src/components/component-link';
import { Repository } from 'src/components/types';
import RefSelector from 'src/sections/repository/components/ref-selector';
import * as styles from 'src/sections/repository/components/ref-selector/ref-selector.style';
import { Ref } from 'src/sections/repository/types';
import urls from 'src/sections/repository/urls';
import { safeEncode } from 'src/utils/path';

import messages from './ref-selector.i18n';

const RefLink = styles.RefLink.withComponent(ComponentLink);

type Props = {
  label?: string;
  repository?: Repository;
  onChange?: (ref: Ref) => void;
};

export default class CommitListRefSelector extends PureComponent<Props> {
  refUrl = (ref: Ref, repository: Repository): string => {
    return urls.ui.commits(repository.full_name, {
      kind: ref.type,
      refName: safeEncode(ref.name),
    });
  };

  render() {
    const { label, repository, onChange } = this.props;

    if (!repository) {
      return null;
    }

    return (
      <RefSelector
        label={label || <FormattedMessage {...messages.allCommitsLabel} />}
        onChange={onChange}
        renderRef={ref => {
          return (
            <RefLink href={this.refUrl(ref, repository)}>{ref.name}</RefLink>
          );
        }}
        repository={repository}
      />
    );
  }
}
